import { useState } from 'react';
import { PERIOD_PRESETS, type PeriodQuery } from '@/api/painel';

/**
 * Seletor de período — presets em chips (mesmos do admin) + intervalo
 * personalizado escondido atrás de "Personalizado". Fica UMA vez, acima de
 * todo o conteúdo da aba: todos os números abaixo usam o mesmo recorte.
 */
export function PeriodPicker({
  value,
  onChange,
  label
}: {
  value: PeriodQuery;
  onChange: (p: PeriodQuery) => void;
  /** Rótulo resolvido pelo backend ("Este mês", "07/10/2026 00:00 a …"). */
  label?: string;
}) {
  const custom = !!(value.date_from && value.date_to);
  const [open, setOpen] = useState(custom);
  const [from, setFrom] = useState(value.date_from ?? '');
  const [to, setTo] = useState(value.date_to ?? '');

  return (
    <div className="flex flex-col gap-2">
      <div className="-mx-4 flex gap-1.5 overflow-x-auto px-4 pb-1 lg:mx-0 lg:flex-wrap lg:px-0">
        {PERIOD_PRESETS.map((p) => {
          const active = !custom && value.preset === p.key;
          return (
            <button
              key={p.key}
              type="button"
              aria-pressed={active}
              onClick={() => {
                setOpen(false);
                onChange({ preset: p.key });
              }}
              className={`h-8 shrink-0 rounded-full px-3.5 text-[13px] font-semibold transition ${
                active ? 'bg-bow-royal text-bow-cream' : 'bg-white text-bow-royal/70 hover:bg-bow-royal/5'
              }`}
            >
              {p.label}
            </button>
          );
        })}
        <button
          type="button"
          aria-pressed={custom}
          onClick={() => setOpen((o) => !o)}
          className={`h-8 shrink-0 rounded-full px-3.5 text-[13px] font-semibold transition ${
            custom ? 'bg-bow-royal text-bow-cream' : 'bg-white text-bow-royal/70 hover:bg-bow-royal/5'
          }`}
        >
          Personalizado
        </button>
      </div>
      {open && (
        <form
          className="flex flex-wrap items-end gap-2 rounded-2xl bg-white p-3 text-[13px] text-bow-royal/70"
          onSubmit={(e) => {
            e.preventDefault();
            if (from && to) onChange({ date_from: from, date_to: to });
          }}
        >
          <label className="flex flex-col gap-1">
            De
            <input
              type="datetime-local"
              value={from}
              onChange={(e) => setFrom(e.target.value)}
              className="rounded-lg border border-bow-cream-3 px-2 py-1.5 text-bow-royal"
            />
          </label>
          <label className="flex flex-col gap-1">
            Até
            <input
              type="datetime-local"
              value={to}
              onChange={(e) => setTo(e.target.value)}
              className="rounded-lg border border-bow-cream-3 px-2 py-1.5 text-bow-royal"
            />
          </label>
          <button
            type="submit"
            disabled={!from || !to}
            className="h-9 rounded-full bg-bow-blue px-4 font-semibold text-white disabled:opacity-40"
          >
            Aplicar
          </button>
        </form>
      )}
      {label && <p className="m-0 text-[12px] text-bow-royal/50">{label} · horário de Brasília</p>}
    </div>
  );
}
